import * as React from 'react';
import { Draft } from '@resi-media/resi-ui';
import { useSetAtom } from 'jotai';
import type { SwitchOrgModalState } from '@studio/components/SwitchOrg';
import { useIsAuthorized } from '@studio/hooks';
import Permissions from '@studio/constants/permissions';
import OpaPermissions from '@studio/constants/opa-permissions';
import { useSession } from '@studio/storeV2/authentication/session-store';
import { setDemoViewAtom, setViewAtom } from '../../admin';
import { useCustomerNames } from '@studio/storeV2/customer/hooks/use-customer-names';

const useAdminInitialization = (): void => {
  const { customerNameData: customerNames } = useCustomerNames();
  const { user } = useSession();
  const hasResiInternalAccess = useIsAuthorized([Permissions.SUDO, Permissions.SUDO_ADMIN], true, [
    OpaPermissions.SUDO,
    OpaPermissions.SUDO_ADMIN,
  ]);
  const setDemoViewState = useSetAtom(setDemoViewAtom);
  const setViewState = useSetAtom(setViewAtom);
  const { isOpen, isOverride, setModalState } = Draft.ModalContext.useModal<SwitchOrgModalState>();

  React.useEffect(() => {
    setViewState(hasResiInternalAccess);
    setDemoViewState(!hasResiInternalAccess);
  }, [hasResiInternalAccess, setDemoViewState, setViewState]);

  React.useEffect(() => {
    if (isOpen && customerNames && isOverride) {
      setModalState({
        customerName: customerNames.find((name) => name.uuid === user?.actualCustomer)?.name,
      });
    }
  }, [customerNames, isOpen, isOverride, setModalState, user?.actualCustomer]);
};

export default useAdminInitialization;
